module.exports = __webpack_public_path__ + "img/notice.e80db898.jpg";